import { Flex, FlexProps } from '@modusign/design-system';
import useResponsiveValue from 'hooks/useResponsiveValue';

export interface ResourceModalFooterProps extends FlexProps<'div'> {}

function ResourceModalFooter(props: ResourceModalFooterProps) {
  const isMobileWidth = useResponsiveValue([true, false]);

  if (isMobileWidth) return null;

  return <Flex px={8} py={6} width="100%" {...props} />;
}

export default ResourceModalFooter;
